
import {createMuiTheme} from '@material-ui/core'

export const theme = createMuiTheme({
  fontFamily: [
    "'Karla', sans-serif",
    'Roboto',
    'Helvetica Neue',
    'Helvetica',
    '-apple-system',
    'Arial',
    'sans-serif'
  ].join(','),
  palette: {
    primary: {
      main: '#3EA0A3',
      light: '#daefff'
    },
    secondary: {
      main: '#3EA0A3',
      light:'#c0d5e4'
    },
    footerButtons:{
      main:'#ededed'
    },
    background: {primary: '#3EA0A3',secondary:'#79d3d5'}
  },
  overrides: {
    MuiTypography:{
      root:{
        fontFamily: [
          'Source Sans Pro',
          'Roboto',
          'Helvetica Neue',
          'Helvetica',
          '-apple-system',
          'Arial',
          'sans-serif'
        ].join(',')
      },
      h1:{
        fontWeight:300
      },
      h2:{
        fontWeight:300
      },
      h3:{
        fontWeight:300
      },
      h4:{
        fontWeight:300
      },
      h5:{
        fontWeight:300
      },
      h6:{
        fontWeight:300
      }
    },
    MuiTab:{
      root:{
        width:'50px !important',
        minWidth:'50px !important',
        height:'50px !important',

          '&$indicator':{
            width:'20px'
          }

      },
      textColorPrimary:{
        color:'#065558',
        '&$selected':{
          color:'white',
          backgroundColor:'#79d3d5'
        }
      },
    },
    MuiTabScrollButton:{
      root:{
        color:'#807c75'
      }
    },
    MuiButton: {
      root: {
        position: 'relative',
        borderRadius: '25px',
        textTransform: 'initial'
      },
      primary: {
        main: '#3EA0A3'
      },
      secondary: {
        main: '#79d3d5',
      },
      outlinedSecondary:{
        main: '#79d3d5'
      },
      contained: {
        boxShadow: 'none !important'
      },
      containedSecondary: {
        color: 'white'
      }
    },
    MuiDrawer:{
      paper:{
        backgroundColor:'#ffffff'
      }
    }
  }
  })
